import { cn } from '@workspace/lib';
import { ButtonIcon } from '../Buttons';

interface ChevronNavigationProps {
  className?: string;
  goNext: () => void;
  goPrev: () => void;
}

export function ChevronNavigation({ className, goNext, goPrev }: ChevronNavigationProps) {
  return (
    <div className={cn('flex flex-row justify-start gap-4 relative z-10', className)}>
      <ButtonIcon
        variant="round"
        iconName="ChevronLeft"
        onClick={goPrev}
        className="bg-transparent cursor-pointer"
        iconSize={24}
      />
      <ButtonIcon
        variant="round"
        iconName="ChevronRight"
        onClick={goNext}
        className="bg-transparent cursor-pointer"
        iconSize={24}
      />
    </div>
  );
}
